<template>
	<!-- v-html="params.headerName" -->
	<div v-html="headerHrml" :title="params.displayName"></div>
	<!-- v-html renders the HTML -->
</template>
  
  <script>
export default {
	props: {
		onePs: Object, // Pass the data object that contains the `id` and `url`
	},
	data() {
		return {
			headerHrml: "",
		};
	},
	created() {
		this.getHeaders();
	},
	methods: {
		// This method will be called when the user clicks on the link
		getHeaders() {
			this.headerHrml = `<span>
  ${
		// Split the keyword by spaces
		this.params.displayName.split(" ").length > 1
			? this.params.displayName.split(" ")[0] +
			  "<br>" +
			  this.params.displayName.split(" ").slice(1).join(" ")
			: this.params.displayName
	}
</span>
`;
		},
	},
};
</script>
  